import { toast } from "react-toastify";
import MultiLanTxt from "../../Components/UI/MultiLanTxt/MultiLanTxt";

const remove = async ({
  actionFetch,
  urlMainEntity,
  paramsId,
  setPreventDraftig,
  notEvUrl,
  idInBody,
  preventSuccessToast,
  forceLtr,
}) => {
  let wasSuccessFull = false;
  const result = await actionFetch({
    method: "DELETE",
    url: notEvUrl
      ? notEvUrl
      : idInBody
      ? `delete/${urlMainEntity}`
      : `delete/${urlMainEntity}/${paramsId}`,
    body: idInBody ? { id: paramsId } : null,
    notEV: notEvUrl ? true : null,
  });
  if (!result.resIsOk && result.response?.message?.includes("delete or update a parent row")) {
    toast.error(
      forceLtr ? "Can not delete a parent record" : <MultiLanTxt tid="CANNOT_DELETE_A_PARENT_ROW" />
    );
  } else if (result.response?.message?.toLowerCase()?.includes("you don't have access")) {
    toast.error(forceLtr ? result.response?.message : "شما دسترسی انجام این عملیات را ندارید");
  } else if (result.resIsOk && result.response?.message === "commands done!") {
    if (setPreventDraftig) {
      setPreventDraftig(true);
    }
    wasSuccessFull = true;
    if (!preventSuccessToast) {
      toast.success(forceLtr ? "Successfully deleted !" : <MultiLanTxt tid="SUCCESSFULLY_DELETED" />);
    }
  } else {
    toast.error(forceLtr ? "Failed to delete !!!" : <MultiLanTxt tid="FAILED_TO_DELETE" />);
  }
  return wasSuccessFull;
};

export default remove;
